module.exports = __webpack_public_path__ + "media/images/banner_nossa_historia-3ac3881f127e38f9b8e48e62bb7694a4.png";